module.exports = __webpack_public_path__ + "static/media/investigative_small.cfdba03b.jpg";